import ToggleBlock, { ToggleOption } from '@/components/ToggleBlock';

export type ProductsToggleProps = {
  className?: string;
  optionClassName?: string;
  value: boolean;
  onChange: (value: boolean) => void;
};

export default function ProductsToggle({
  className,
  optionClassName,
  value,
  onChange,
}: ProductsToggleProps) {
  return (
    <ToggleBlock<boolean>
      className={className}
      value={value}
      onChange={onChange}>
      <ToggleOption className={optionClassName} value={true}>
        All
      </ToggleOption>
      <ToggleOption className={optionClassName} value={false}>
        Open
      </ToggleOption>
    </ToggleBlock>
  );
}
